import { Base } from '@core/base/base'
import { useStore as getStore } from '@nanostores/react'
import { map, MapStore } from 'nanostores'

export class BaseModule<State extends object> extends Base {
    readonly #store: MapStore<State>

    constructor(state: State, name: string) {
        super(name)
        this.#store = map<State>(state)
        this.useLogger()
    }

    get store(): MapStore<State> {
        return this.#store
    }

    useStore() {
        return getStore(this.#store)
    }

    useLogger() {
        if (this.envVars.REACT_APP_ENV !== 'production') {
            this.store.listen((value, changedKey) => {
                this.log(
                    `[ store ] [ ${String(changedKey)} ] \n\n[ ${JSON.stringify(
                        // @ts-ignore
                        value[changedKey]
                    )} ]\n\n`
                )
            })
        }
    }
}
